import ConfirmPurchaseForm from './forms/ConfirmPurchaseForm.vue'
import BillingSettings from './forms/BillingSettings.vue'
import PaymentForm from './forms/PaymentForm.vue'
import SetupWizardConfigType from '@/@okmenu/components/wizards/setup-wizard/SetupWizardConfigType'

const SellingTypesWizardConfig: SetupWizardConfigType = {
  tabs: [
    {
      title: 'subscription.confirm-purchase',
      icon: 'feather icon-shopping-bag',
      maxWidth: '808px',
      narrowCard: true,
      hide: false,
      canSkip: true,
      props: {},
      component: ConfirmPurchaseForm,
      nextButtonTitle: 'payment.pay',
    },
    {
      title: 'payment.billing-settings',
      icon: 'feather icon-shopping-bag',
      maxWidth: '808px',
      narrowCard: true,
      hide: false,
      canSkip: false,
      props: {},
      component: BillingSettings,
      nextButtonTitle: 'forms.next',
    },
    {
      title: 'payment.payment',
      icon: 'feather icon-shopping-bag',
      maxWidth: '808px',
      hide: false,
      canSkip: false,
      props: {},
      component: PaymentForm,
      nextButtonTitle: 'payment.pay',
    },
  ],
}

export default SellingTypesWizardConfig
